<div class="card my-2">
  <div class="card-body">
    <div class="d-flex justify-content-between mb-4">
      <div class="custom-wallet">
        <div class="custom-wallet-input-wrapper">
          <p class="custom-wallet-input py-0 text-uppercase">
            {{ title }}
          </p>
        </div>
        @if (showStatus) {
          <span
            role="button"
            [class]="'status cur ms-2 wallet-status-' + status?.toLowerCase()"
            >{{ getWalletStatusString }}</span
          >
        }
      </div>
      <div class="topleft">
        <span>
          @if (tag === "PREPAID") {
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
              style="position: relative; top: -2px"
            >
              <rect
                x="0.5"
                y="4.37659"
                width="13.3949"
                height="10.1234"
                rx="2.7"
                stroke="
                    #86B5FF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.7959 6.99408H12.7588C14.1088 6.99408 15.2033 8.08848 15.2033 9.4385C15.2033 10.7885 14.1089 11.8829 12.7588 11.8829H10.7959C9.44588 11.8829 8.35147 10.7885 8.35147 9.4385C8.35147 8.08848 9.44587 6.99408 10.7959 6.99408Z"
                fill="white"
                stroke="
                    #86B5FF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.76199 3.16156L10.1762 1L11.0786 3.16156"
                stroke="
                    #86B5FF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                cx="10.7962"
                cy="9.43838"
                r="0.731473"
                fill="white"
                stroke="#86B5FF"
                stroke-width="0.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          @if (tag !== "PREPAID") {
            <svg
              class="me-1"
              width="16"
              height="15"
              viewBox="0 0 22 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.0525 1.77476C14.7566 1.75058 14.3724 1.75 13.8 1.75H3C2.30964 1.75 1.75 2.30965 1.75 3C1.75 3.69036 2.30964 4.25 3 4.25H11H16.2H16.2321H16.25V4.2C16.25 3.62757 16.2494 3.24336 16.2252 2.94748C16.2018 2.66036 16.1599 2.52307 16.1138 2.43251C15.9939 2.19731 15.8027 2.00608 15.5675 1.88624C15.4769 1.8401 15.3396 1.79822 15.0525 1.77476ZM3 0.25C1.48122 0.25 0.25 1.48122 0.25 3V14.2V14.2321V14.2321C0.249993 15.045 0.249987 15.7006 0.293364 16.2315C0.338026 16.7781 0.432386 17.2582 0.658726 17.7025C1.01825 18.4081 1.59193 18.9818 2.29754 19.3413C2.74175 19.5676 3.2219 19.662 3.76853 19.7066C4.29942 19.75 4.955 19.75 5.76779 19.75H5.76788H5.8H16.2H16.2321H16.2322C17.045 19.75 17.7006 19.75 18.2315 19.7066C18.7781 19.662 19.2582 19.5676 19.7025 19.3413C20.4081 18.9818 20.9817 18.4081 21.3413 17.7025C21.5676 17.2582 21.662 16.7781 21.7066 16.2315C21.75 15.7006 21.75 15.045 21.75 14.2321V14.2V14V10V9.8V9.76788C21.75 8.95505 21.75 8.29944 21.7066 7.76853C21.662 7.2219 21.5676 6.74176 21.3413 6.29754C20.9817 5.59193 20.4081 5.01825 19.7025 4.65873C19.2582 4.43239 18.7781 4.33803 18.2315 4.29337C18.0812 4.28109 17.921 4.27229 17.75 4.26598V4.2V4.16955C17.75 3.6354 17.75 3.18956 17.7203 2.82533C17.6892 2.44545 17.6221 2.08879 17.4503 1.75153C17.1866 1.23408 16.7659 0.813385 16.2485 0.549733C15.9112 0.377889 15.5546 0.310778 15.1747 0.27974C14.8104 0.249982 14.3646 0.24999 13.8305 0.25H13.8304H13.8H3ZM20.2495 9.25C20.2478 8.68053 20.2407 8.24665 20.2116 7.89068C20.1745 7.43681 20.1054 7.17604 20.0048 6.97852C19.789 6.55516 19.4448 6.21095 19.0215 5.99524C18.824 5.8946 18.5632 5.82547 18.1093 5.78838C17.6467 5.75058 17.0525 5.75 16.2 5.75H11H3C2.54989 5.75 2.12503 5.64186 1.75 5.45015V14.2C1.75 15.0525 1.75058 15.6467 1.78838 16.1093C1.82547 16.5632 1.8946 16.824 1.99524 17.0215C2.21095 17.4448 2.55516 17.7891 2.97852 18.0048C3.17604 18.1054 3.43681 18.1745 3.89068 18.2116C4.35331 18.2494 4.94755 18.25 5.8 18.25H16.2C17.0525 18.25 17.6467 18.2494 18.1093 18.2116C18.5632 18.1745 18.824 18.1054 19.0215 18.0048C19.4448 17.7891 19.789 17.4448 20.0048 17.0215C20.1054 16.824 20.1745 16.5632 20.2116 16.1093C20.2407 15.7534 20.2478 15.3195 20.2495 14.75H19C17.4812 14.75 16.25 13.5188 16.25 12C16.25 10.4812 17.4812 9.25 19 9.25H20.2495ZM20.25 13.25V10.75H19C18.3096 10.75 17.75 11.3096 17.75 12C17.75 12.6904 18.3096 13.25 19 13.25H20.25Z"
                fill="#86B5FF"
              />
            </svg>
          }
          {{ tag }}</span
        >
      </div>
    </div>

    @if (!canViewBalance) {
      <common-alert-banner
        [title]="starterTitle"
        [description]="starterDescription"
      ></common-alert-banner>
    }

    @if (showAdditionalButton && status == WalletTypeEnum.ACTIVE) {
      <div class="row mb-2 ms-0 me-0">
        <div class="walletGlobalBalanceWrapper col-12 d-flex">
          <div
            class="walletGlobalBalanceInnerWrapper justify-content-between d-flex flex-grow-1"
          >
            <p
              class="totalLabeltext m-0 d-flex align-items-center justify-content-center"
            >
              Prepaid Estimated balance
            </p>
            <p
              class="walletTotalAmount m-0 d-flex align-items-center justify-content-end"
            >
              @if (canViewBalance) {
                <span class="font-weight-600">
                  {{
                    globalPrepaidBalance.split(".")[0]
                      | caiNumberFormatter: false : 0 : true
                  }}.</span
                >
              }
              <span class="font-total-normal">
                @if (canViewBalance) {
                  <span>{{
                    (globalPrepaidBalance.split(".")[1] ?? "00").padEnd(2, "0")
                  }}</span>
                }
                @if (!canViewBalance) {
                  <span class="font-weight-600">--</span>
                }
                {{ walletDetails?.default_currency || "SGD" }}
              </span>
            </p>
            @if (canViewBalance) {
              <span
                class="globalBalancetooltip"
                caiPopover
                [enablePopover]="true"
                [target]="idTooltip1"
                [allowHoverOnTarget]="true"
                [placement]="'right-start'"
                role="button"
              >
                <span>
                  <img
                    height="10px"
                    alt="info icon"
                    src="/assets/media/icons/search-results/info.svg"
                  />
                </span>
                <ng-template #idTooltip1>
                  <kt-popover
                    [arrowColor]="'#679EC6'"
                    [bgColor]="'#679EC6'"
                    [textColor]="'white'"
                    [placement]="'right-start'"
                    [messageHtml]="defaultGlobalSumTooltip"
                    style="max-width: 255px !important"
                  >
                  </kt-popover>
                </ng-template>
              </span>
            }
          </div>
        </div>
      </div>
    }
    @if (walletDetails?.balances && status != WalletTypeEnum.BLOCKED) {
      <div [ngClass]="{ 'mt-5': tag === 'PAYLATER' }" class="row ms-0 me-0">
        @for (item of walletDetails?.balances; track item) {
          <div
            class="col-12 border-1 d-flex bg-currency-wrapper mb-5-px default-currency align-items-center"
          >
            <div class="flag-container flex-wrap">
              <div
                class="currency-flag currency-flag-img-size"
                [ngClass]="'currency-flag-' + item.currency?.toLowerCase()"
              ></div>
              <p class="m-0 color-gray">{{ item.currency?.toUpperCase() }}</p>
            </div>
            <p class="ms-1 d-flex flex-grow-1 m-0 align-items-center">
              <span class="wallet-currency mx-3 font-weight-500"
                ><span class="me-1 wallet-set-currency currency-symbol">{{
                  getCurrencySymbol(item.currency)
                }}</span>
                @if (canViewBalance) {
                  <span class="font-weight-600 wallet-set-currency"
                    >{{
                      item.amount?.toString().split(".")[0]
                        | caiNumberFormatter: false : 0 : true
                    }}.</span
                  >
                }
                @if (!canViewBalance) {
                  <span class="wallet-set-currency font-weight-600">--</span>
                }
                @if (canViewBalance) {
                  <span class="font-weight-600">{{
                    (item.amount?.toString().split(".")[1] ?? "00").padEnd(
                      2,
                      "0"
                    )
                  }}</span>
                }
              </span>
            </p>
            @if (
              tag === "PREPAID" &&
              item.currency === walletDetails?.default_currency
            ) {
              <span
                caiPopover
                [enablePopover]="true"
                [target]="idTooltip2"
                [allowHoverOnTarget]="true"
                [placement]="'right-start'"
                role="button"
                class="tooltip-top-index"
              >
                <span>
                  <img
                    alt="info icon"
                    src="/assets/media/icons/search-results/info.svg"
                  />
                </span>
                <ng-template #idTooltip2>
                  <kt-popover
                    [arrowColor]="'#679EC6'"
                    [bgColor]="'#679EC6'"
                    [textColor]="'white'"
                    [placement]="'right-start'"
                    [messageHtml]="defaultCurrencyTooltip"
                    style="max-width: 255px !important"
                  >
                  </kt-popover>
                </ng-template>
              </span>
            }
            @if (
              item.currency ===
                (tag === "PREPAID"
                  ? walletDetails?.default_currency
                  : walletDetails?.default_pay_later_currency) && canViewBalance
            ) {
              <p
                class="mb-0 ms-4 m-0 def-c-style align-item-center d-flex"
                i18n="@@wallet-status.default-currency"
              >
                Default Currency
              </p>
            }
            @if (
              walletDetails?.balances?.length > 1 &&
              item.currency !==
                (tag === "PREPAID"
                  ? walletDetails?.default_currency
                  : walletDetails?.default_pay_later_currency) &&
              canViewBalance
            ) {
              <p
                (click)="onSetDefaultCurrency(item.currency)"
                class="mb-0 ms-3 m-0 set-c-style d-flex align-item-center"
                [ngClass]="{
                  disabled:
                    status != WalletTypeEnum.ACTIVE || +item.currency <= 0,
                }"
                i18n="@@wallet-status-set-as-default"
              >
                SET AS DEFAULT
              </p>
            }
          </div>
        }
      </div>
    }
    @if (
      (!walletDetails?.balances ||
        !walletDetails?.balances?.length ||
        status == WalletTypeEnum.BLOCKED) &&
      canViewBalance
    ) {
      <div class="wallet-p text-center">
        <p class="px-md-5 px-2 py-md-5 py-3">
          {{ description }}
        </p>
      </div>
    }
    @if (showAdditionalButton) {
      <div class="row mt-3 mb-2">
        <div
          class="col wallet-active-status"
          [routerLink]="walletBaseUrl + '/top-up'"
          [ngClass]="{
            'disabled-wrapper':
              status != WalletTypeEnum.ACTIVE || !canViewBalance,
          }"
        >
          <div class="image-size">
            <img
              src="/assets/media/icons/wallet/dollar_round.svg"
              alt="dollar round"
            />
          </div>
          <p class="image-font" i18n="@@wallet-status.top-up">Top Up</p>
        </div>
        <div
          class="col wallet-active-status"
          [routerLink]="'../pay-to'"
          [queryParams]="{ category: 'CURRENCY_CONVERSION' }"
          [ngClass]="{
            'disabled-wrapper':
              status != WalletTypeEnum.ACTIVE || !canViewBalance,
          }"
          id="currency-conversion"
        >
          <div class="image-size">
            <img
              src="/assets/media/icons/wallet/wallet_conversation.svg"
              alt="dollar conversation"
            />
          </div>
          <p class="image-font" i18n="@@wallet-status.currency-conversion">
            Currency Conversion
          </p>
        </div>
        <div
          class="col wallet-active-status"
          [routerLink]="walletBaseUrl + '/history'"
          [ngClass]="{
            'disabled-wrapper':
              status != WalletTypeEnum.ACTIVE || !canViewBalance,
          }"
        >
          <div class="image-size">
            <img
              src="/assets/media/icons/wallet/wallet_duration.svg"
              alt="dollar duration"
            />
          </div>
          <p class="image-font" i18n="@@wallet-status.history">History</p>
        </div>
        <div
          class="col wallet-active-status refund-button"
          [routerLink]="'/payout'"
          [ngClass]="{
            'disabled-wrapper':
              status != WalletTypeEnum.ACTIVE || !canViewBalance,
          }"
        >
          <div class="image-size">
            <img
              src="/assets/media/icons/wallet/wallet_witharaw.svg"
              alt="dollar witharaw"
            />
          </div>
          <p class="image-font" i18n="@@wallet-status.payout">PayOut</p>
        </div>
      </div>
    }

    <div class="active-status-wrapper position-relative d-flex">
      @if (
        status == WalletTypeEnum.INACTIVE && showActivateButton && isPageReady
      ) {
        <span class="text-center active-status activation-button">
          <a
            class="btn wallet-btn ms-5"
            i18n="@@wallet-status.activate-my-wallet"
            type="button"
            [href]="activationLink"
            target="_blank"
          >
            ACTIVATE MY WALLET
          </a>
        </span>
      }
      @if (status == WalletTypeEnum.ACTIVE && false) {
        <span class="section-balance w-100">
          <div class="available-balance align-items-center">
            <div
              class="w-50 px-md-3 px-0 text-right"
              i18n="@@wallet-status.total-balance-available"
            >
              Total available balance in the wallet :
            </div>
            <div class="w-50 px-md-3 px-0 text-right wallet-balance">
              $ 7,876.<span class="">89 USD</span>
            </div>
          </div>
        </span>
      }
      @if (status == WalletTypeEnum.ACTIVE && false) {
        <span
          caiPopover
          [enablePopover]="enablePopover"
          [target]="idTooltip3"
          [allowHoverOnTarget]="true"
          [placement]="titleToolTipPlacement"
        >
          <span class="icon-set">
            <img
              alt="info icon"
              src="/assets/media/icons/search-results/info.svg"
            />
          </span>
          <ng-template #idTooltip3>
            <kt-popover
              [arrowColor]="'#679EC6'"
              [bgColor]="'#679EC6'"
              [textColor]="'white'"
              [width]="titleToolTipWidth"
              [placement]="titleToolTipPlacement"
              [header]="titleToolTipHeader"
              [message]="titleToolTipMessage"
              [footer]="titleToolTipFooter"
              style="max-width: 255px !important"
            >
            </kt-popover>
          </ng-template>
        </span>
      }
    </div>
  </div>
</div>
@if (status != WalletTypeEnum.INACTIVE && showAddWalletButton && false) {
  <div class="col add-new-wallet d-flex align-items-center mt-4 disabled">
    <img
      src="/assets/media/icons/wallet_large.svg"
      alt="wallet_icon"
      height="27px"
      width="30.67px"
    />
    <span class="text-add-wallet ms-3">ADD NEW WALLET</span>
  </div>
}
